import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      layout: 'home'
    }
  },
  {
    path: '/on-chain-data',
    name: 'RWA',
    component: () => import('@/views/RWA.vue'),
    meta: {
      layout: 'home'
    }
  },
  {
    path: '/term-of-use',
    name: 'TermOfUse',
    component: () => import('@/views/TermOfUse.vue'),
    meta: {
      layout: 'home'
    }
  },
  {
    path: '/compliance-disclaimer',
    name: 'ComplianceDisclaimer',
    component: () => import('@/views/ComplianceDisclaimer.vue'),
    meta: {
      layout: 'home'
    }
  },
  {
    path: '/white-paper',
    name: 'WhitePaper',
    component: () => import('@/views/WhitePaper.vue'),
    meta: {
      layout: 'home'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器前进后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到顶部
    return { top: 0 }
  }
})

export default router 